import { useClientHandle } from '@urql/vue';
import useUrqlUpdate from 'ui/hooks/useUrqlUpdate';
import {
  LogoutPortalContactDocument as Document,
  type LogoutPortalContactMutation as Mutation,
  type LogoutPortalContactMutationVariables as Variables,
} from 'ui/graphql/web/generated/graphql';

export const usePartnerPortalLogout = (onSuccess: () => void) => {
  const { onSubmitUrql, fetching } = useUrqlUpdate<Mutation, Variables>(
    useClientHandle('urql-web'),
    Document,
    'logoutPortalContact',
  );
  const success = ref(false);
  const onLogout = () => onSubmitUrql({ }, {
    onSuccess: () => {
      success.value = true;
      onSuccess();
    },
  });

  return {
    success,
    onLogout,
    fetching,
  };
};
